import * as utils from "../core/utils.mjs";
import {ControllerManager} from "SRC/controllers/controllermanager2.mjs";
import {View} from "SRC/components/view.component.mjs";
import {mapInit} from "../test-map-init.mjs";

import "../css/all.css"

utils.configTest('Test Controller Manager', test1, '');


test1();

function test1(){

    var view = new View();
    var controllerManager;
    
    mapInit().then(()=>{
        controllerManager = new ControllerManager(view);
    })


    utils.insertDoc(view, "body");

}